import { ParametreCampagne } from './parametre-campagne.model';
import { ContactReferent } from './contact-referent.model';
import { RefSoustypeUtilisateur } from '../../droits/models/ref-soustype-utilisateur.model';
import { Terroir } from './terroir.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EntrepriseReferent {
    static jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        departement: { key: 'departement', optional: true, default: '' },
        sousType: { key: 'sousType', converter: new (ClassConverterFactory.build(RefSoustypeUtilisateur))(), optional: true },
        referentRecolteList: { key: 'referentRecolteList', converter: new (ArrayClassConverterFactory.build(ContactReferent))(), default: () => [] },
        referentStockList: { key: 'referentStockList', converter: new (ArrayClassConverterFactory.build(ContactReferent))(), default: () => [] },
        referentEcoulementList: { key: 'referentEcoulementList', converter: new (ArrayClassConverterFactory.build(ContactReferent))(), default: () => [] },
        referentInventaireList: { key: 'referentInventaireList', converter: new (ArrayClassConverterFactory.build(ContactReferent))(), default: () => [] }
    };

    public parametreCampagne: ParametreCampagne;

    public terroir: Terroir;
    public id: number;
    public raisonSociale: string;
    public departement: string;
    public sousType: RefSoustypeUtilisateur;
    public referentRecolteList: ContactReferent[];
    public referentStockList: ContactReferent[];
    public referentEcoulementList: ContactReferent[];
    public referentInventaireList: ContactReferent[];
}
